<template>
  <page :loading="!Array.isArray(leaderboards)" :err="fatalErr" hide-footer>
    <b-row>
      <b-col cols="12" md="6" offset-md="3">
        <h2 class="my-3 text-center">{{ $t('leaderboards.all-leaderboards') }}</h2>

        <b-card no-body class="mt-3">
          <b-list-group flush>
            <b-list-group-item v-for="leaderboard in leaderboards" :key="leaderboard.id" class="flex-column align-items-start"
              :to="{ name: 'LeaderboardShow', params: { leaderboardID: leaderboard.id } }">
                <div class="d-flex w-100 justify-content-between align-items-center">
                  {{ leaderboard.name }}
                  <span class="flex-fill"/>
                  <template v-if="leaderboard.startDate || leaderboard.endDate">
                    <small v-if="leaderboard.endDate && leaderboard.endDate < Date.now()">Ended on {{ leaderboard.endDate | formatDate('DD/MMM') }}</small>
                    <small v-else-if="leaderboard.startDate && leaderboard.startDate > Date.now()">Starts on {{ leaderboard.startDate | formatDate('DD/MMM') }}</small>
                    <small v-else-if="leaderboard.endDate">Ends on {{ leaderboard.endDate | formatDate('DD/MMM') }}</small>
                    <small v-else-if="leaderboard.startDate">Started on {{ leaderboard.startDate | formatDate('DD/MMM') }}</small>
                    <small v-if="leaderboard.status !== 'ACTIVE'">&nbsp;&ndash;&nbsp;</small>
                  </template>
                  <template v-if="leaderboard.status !== 'ACTIVE'">
                    <small v-if="leaderboard.status === 'INACTIVE'">Inactive</small>
                    <small v-else-if="leaderboard.status === 'DELETED'">Deleted</small>
                  </template>
                </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>

      </b-col>
    </b-row>
  </page>
</template>

<script>
import LeaderboardIndexQuery from '@/graphql/queries/LeaderboardIndex.gql';
import Page from '@/components/Page';

export default {
  components: {
    Page,
  },
  data: () => ({
    fatalErr: null,
  }),
  apollo: {
    leaderboards: {
      query: LeaderboardIndexQuery,
      fetchPolicy: 'cache-and-network',
      update: ({ company: { leaderboards } }) => leaderboards,
      error(err) {
        this.fatalErr = `${err}`;
      },
    },
  },
  metaInfo() {
    return {
      title: this.$t('leaderboards.all-leaderboards'),
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/User/LeaderboardIndex.vue